export default __webpack_public_path__ + "static/media/blog-img244.e3d1eb50.jpg";